// import SubtleBackground from "../components/SubtleBackground";
// import React, { useState } from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import Sidebar from "../components/Sidebar";

// const Layout = () => {
//   const location = useLocation();

//   const isFormPage =
//     location.pathname.includes("add") ||
//     location.pathname.includes("edit");

//   const isFullPage =
//     isFormPage ||
//     location.pathname.includes("user-list") ||
//     location.pathname.includes("rti-list") ||
//     location.pathname.includes("occupancy-list") ||
//     location.pathname.includes("developer-list");

//   // TRACK SIDEBAR STATE
//   const [collapsed, setCollapsed] = useState(isFullPage);

//   return (
//   <div id="app-shell" className="h-screen overflow-hidden flex relative bg-[#f5f7fb]">

//     <SubtleBackground />

//     <Sidebar
//       collapsed={collapsed}
//       setCollapsed={setCollapsed}
//       forceCollapsed={isFullPage}
//     />

//     <div
//       id="app-content"
//       className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 relative z-10 ${
//         collapsed ? "ml-16" : "ml-64"
//       }`}
//     >
//       <div className="flex-1 overflow-y-auto scrollbar-hide p-6 md:p-8">
//         <Outlet />
//       </div>
//       <footer className="border-t border-gray-200 px-2 py-2 text-center text-[11px] text-gray-500 bg-white/30 backdrop-blur-sm">
//         Developed by{" "}
//         <span className="font-medium text-gray-700">A K ENTERPRISES</span>{" "}
//         ©2026 ALL RIGHTS RESERVED
//       </footer>
//     </div>
//   </div>
// );
// };

// export default Layout;



// import SubtleBackground from "../components/SubtleBackground";
// import React, { useState } from "react";
// import { Outlet, useLocation } from "react-router-dom";
// import Sidebar from "../components/Sidebar";

// const Layout = () => {
//   const location = useLocation();

//   const isFormPage =
//     location.pathname.includes("add") ||
//     location.pathname.includes("edit");

//   const isFullPage =
//     isFormPage ||
//     location.pathname.includes("user-list") ||
//     location.pathname.includes("rti-list") ||
//     location.pathname.includes("occupancy-list") ||
//     location.pathname.includes("developer-list");

//   const [collapsed, setCollapsed] = useState(isFullPage);

//   return (
//     <div id="app-shell" className="h-screen overflow-hidden flex relative bg-[#f5f7fb]">

//       <SubtleBackground />

//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         forceCollapsed={isFullPage}
//       />

//       <div
//         id="app-content"
//         className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 relative z-10 ${
//           collapsed ? "ml-16" : "ml-64"
//         }`}
//       >
//         <div id="app-scroll" className="flex-1 overflow-y-auto scrollbar-hide p-6 md:p-8">
//           <Outlet />
//         </div>
//         <footer className="border-t border-gray-200 px-2 py-2 text-center text-[11px] text-gray-500 bg-white/30 backdrop-blur-sm">
//           Developed by{" "}
//           <span className="font-medium text-gray-700">A K ENTERPRISES</span>{" "}
//           ©2026 ALL RIGHTS RESERVED
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default Layout;


import SubtleBackground from "../components/SubtleBackground";
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const Layout = () => {
  const location = useLocation();

  const isFormPage =
    location.pathname.includes("add") ||
    location.pathname.includes("edit");

  const isFullPage =
    isFormPage ||
    location.pathname.includes("user-list") ||
    location.pathname.includes("rti-list") ||
    location.pathname.includes("occupancy-list") ||
    location.pathname.includes("developer-list");

  // TRACK SIDEBAR STATE
  const [collapsed, setCollapsed] = useState(isFullPage);

  return (
  <div id="app-shell" className="h-screen overflow-hidden flex relative bg-[#f5f7fb]">

    <SubtleBackground />

    <Sidebar
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      forceCollapsed={isFullPage}
    />

    <div
      id="app-content"
      className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 relative z-10 ${
        collapsed ? "ml-16" : "ml-64"
      }`}
    >
      <div className="flex-1 overflow-y-auto scrollbar-hide p-6 md:p-8">
        <Outlet />
      </div>
      <footer className="border-t border-gray-200 px-2 py-2 text-center text-[11px] text-gray-500 bg-white/30 backdrop-blur-sm">
        Developed by{" "}
        <span className="font-medium text-gray-700">A K ENTERPRISES</span>{" "}
        ©2026 ALL RIGHTS RESERVED
      </footer>
    </div>
  </div>
);
};

export default Layout;